import api from '../../api/axios';

export const GET_WEBHOOK_DATA_REQUEST = 'GET_WEBHOOK_DATA_REQUEST';
export const GET_WEBHOOK_DATA_SUCCESS = 'GET_WEBHOOK_DATA_SUCCESS';
export const GET_WEBHOOK_DATA_FAILURE = 'GET_WEBHOOK_DATA_FAILURE';

export const getWebhookData = (params = {}) => async (dispatch) => {
  dispatch({ type: GET_WEBHOOK_DATA_REQUEST });
  
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    // Call API to get webhook data
    const response = await api.post(`dashboard/getWebhookData`, {
      "userId": params.userId || "",
      "startDate": params.startDate || "",
      "endDate": params.endDate || ""
      // headers: {
      //   Authorization: `Bearer ${token}`
      // }
    });

    const envelope = response?.data || {};
    if (envelope.success) {
      dispatch({
        type: GET_WEBHOOK_DATA_SUCCESS,
        payload: envelope || {}
      });
      return { success: true, data: envelope };
    } else {
      throw new Error(envelope.message || 'Failed to fetch webhook data');
    }
  } catch (error) {
    dispatch({
      type: GET_WEBHOOK_DATA_FAILURE,
      error: error.message || 'Failed to fetch webhook data'
    });
    return { success: false, error: error.message };
  }
};
